module.exports = ".page-content{padding:30px}"